import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import boast from "../../images/boast-icon.svg";
import content from "../../images/content-icon.svg";
import customization from "../../images/customization-icon.svg";
import fastPerformance from "../../images/fast-performance-icon.svg";
import smartFeature from "../../images/smart-feature-icon.svg";
import support from "../../images/support-icon.svg";

const features = [
  {
    id: "1",
    name: "Smart Features",
    des: "Get your blood tests delivered at let home collect sample from the victory of the managments.",
    icon: smartFeature,
  },
  {
    id: "2",
    name: "Fast Performance",
    des: "Get your blood tests delivered at let home collect sample from the victory of the managments.",
    icon: fastPerformance,
  },
  {
    id: "3",
    name: "Unlimited Content",
    des: "Get your blood tests delivered at let home collect sample from the victory of the managments.",
    icon: content,
  },
  {
    id: "4",
    name: "Ultimate Customization",
    des: "Get your blood tests delivered at let home collect sample from the victory of the managments.",
    icon: customization,
  },
  {
    id: "5",
    name: "Boost Productivity",
    des: "Get your blood tests delivered at let home collect sample from the victory of the managments.",
    icon: boast,
  },
  {
    id: "6",
    name: "Customer Support",
    des: "Get your blood tests delivered at let home collect sample from the victory of the managments.",
    icon: support,
  },
];

const QualityFeatures = () => {
  return (
    <div>
      <Container sx={{ py: 6 }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography className="sub-title" variant="subtitle1">
            Quality features
          </Typography>
          <Typography className="section-title" variant="h3">
            Meet exciting feature of app
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1, mt: 3 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 2, sm: 8, md: 12 }}
          >
            {features.map((feature) => (
              <Grid key={feature.id} item xs={2} sm={4} md={4}>
                <Paper
                  sx={{
                    p: 3,
                    boxShadow: 0,
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: { xs: 2, md: 4 },
                    textAlign: { xs: "center", md: "inherit" },
                  }}
                >
                  <img className="feature-img" src={feature.icon} alt="" />
                  <Box>
                    <Typography
                      sx={{ fontSize: 18, fontWeight: 700, my: 2 }}
                      variant="h4"
                    >
                      {feature.name}
                    </Typography>
                    <Typography variant="body1">{feature.des}</Typography>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default QualityFeatures;
